import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Ol, OlFilters, OlSort } from '../../lib/types/models/ol/ol'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getOls(input: PaginationRequest<OlFilters, string, Version, OlSort> = {}) {
  if (!input.sort) input.sort = { mainContactFirstName: 'asc' }
  return restApiClient
    .url(encodeNestedObject<PaginationRequest<OlFilters>>(API.ols.getAll.url, input))
    .get<PaginationResponse<Ol>>()
}
